export const PAYMENT_STATUS = {
  INIT: "init",
  CONFIRMING: "confirming",
  PROCESSING: "processing",
  SUCCESS: "success",
  FAIL: "fail",
};

export default PAYMENT_STATUS;
